import { render, staticRenderFns } from "./CallToActionsSmall.vue?vue&type=template&id=3b2ee2d9&scoped=true"
import script from "./CallToActionsSmall.vue?vue&type=script&lang=js"
export * from "./CallToActionsSmall.vue?vue&type=script&lang=js"
import style0 from "./CallToActionsSmall.vue?vue&type=style&index=0&id=3b2ee2d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ee2d9",
  null
  
)

export default component.exports